<template>
  <svg class="loading-circular" :style="{'width': (cx + strokeWidth) * 2 + 'px', 'height': (cy + strokeWidth) * 2 +
  'px'}">
    <circle class="loading-path"
            :style="{'stroke-dasharray': `${Math.PI * r / 3}, ${Math.PI * r / 3}`}"
            :cx="cx"
            :cy="cy"
            :r="r"
            fill="none"
            :stroke="stroke"
            :stroke-width="strokeWidth"
    ></circle>
  </svg>
</template>

<script>
  export default {
    name: "svgLoading",
    props: {
      cx: {
        type: [Number],
        default: 16,
      },
      cy: {
        type: [Number],
        default: 16,
      },
      r: {
        type: [Number],
        default: 8,
      },
      stroke: {
        type: [String],
        default: '#ffffff',
      },
      strokeWidth: {
        type: [Number],
        default: 2,
      }
    },
    data() {
      return {
      }
    },
    watch: {
    },
    methods: {
    },
    mounted() {
    }
  }
</script>

<style lang="less">
  @keyframes dash {
    0% {
      stroke-dashoffset: 100%;
    }
    100% {
      stroke-dashoffset: 3%;
    }
  }
  .loading-circular {
    display: inline-block;
  }
  .loading-path {
    stroke-dashoffset: 0;
    animation: dash 1s linear infinite;
    stroke-linecap: round;
  }
</style>



// WEBPACK FOOTER //
// src/components/new/common/svgLoading.vue